import React from 'react';
import { useFeatureFlags } from '../FeatureFlagContext';
import MenuLink from './MenuLink';
import { StyledMenuItem } from './StyledMenuComponents';
export default function FormsLink({ isBank, bankStatus, wealthStatus, investStatus, isInvest, isWealthClient, routeInEmber, routeLinks, hasActiveDepositAccounts, closeMenu, }) {
    const featureFlags = useFeatureFlags();
    const { isWealthManagement } = featureFlags;
    const isBankDown = bankStatus === 'down';
    const isInvestDown = investStatus === 'down';
    const isWealthDown = wealthStatus === 'down';
    const isBankAvailable = isBank && (hasActiveDepositAccounts || isBankDown);
    const canShowInvest = isInvest && !isInvestDown;
    const canShowWealth = isWealthClient && !isWealthDown;
    const isInvestAvailable = isWealthManagement
        ? canShowInvest || canShowWealth
        : canShowInvest;
    // if ANY of the forms-having LOBs the user is eligible to see are NOT in outage and isn't ccOnly, show the Forms link
    const showLink = isBankAvailable || isInvestAvailable;
    if (showLink) {
        return (React.createElement(StyledMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.forms.bankUrl, text: routeLinks.forms.content, routeInEmber: routeInEmber, closeMenu: closeMenu })));
    }
    return React.createElement(React.Fragment, null);
}
//# sourceMappingURL=FormsLink.js.map